import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import RefundRule from '~/features/ticket/components/RefundRule'
import TicketInfo from '~/features/ticket/components/TicketInfo'
import TicketRefundTabs from '~/features/ticket/components/TicketRefundTabs'
import { type ExtendedShopInfo } from '~/features/ticket/types/ticket'
import { ticketInfoTabState } from '~/shared/states'
import theme from '~/shared/styles/theme'

type Props = {
  data: ExtendedShopInfo
}

function TicketInfoAndRefundRule({ data }: Props) {
  const [ticketInfoTab, setTicketInfoTab] = useRecoilState(ticketInfoTabState)

  const ticketInfo: Pick<
    ExtendedShopInfo,
    'ticket_type' | 'ticket_rule' | 'buy_method'
  > = {
    ticket_type: data.ticket_type,
    ticket_rule: data.ticket_rule,
    buy_method: data.buy_method,
  }

  const refundRule: Pick<ExtendedShopInfo, 'refund_rule'> = {
    refund_rule: data.refund_rule,
  }

  return (
    <Wrapper>
      <TicketRefundTabs
        tabContents={['티켓 정보', '취소 및 환불 규정']}
        selectedTab={ticketInfoTab}
        $size="md"
        setSelectTab={setTicketInfoTab}
      />
      {ticketInfoTab === 0 ? (
        <TicketInfo data={ticketInfo} />
      ) : ticketInfoTab === 1 ? (
        <RefundRule data={refundRule} />
      ) : null}
    </Wrapper>
  )
}

export default TicketInfoAndRefundRule

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 36px 24px;

  background-color: white;
  border-radius: 12px;

  @media ${theme.device.large} {
    padding: 16px;
  }
`
